export var Translate;
(function (Translate) {
    /**
     * Report missing translation
     */
    let Missing;
    (function (Missing) {
        Missing.path = 'translate/missing';
    })(Missing = Translate.Missing || (Translate.Missing = {}));
})(Translate || (Translate = {}));
